enum URL_PATH {
  MAIN = "main-dashboard",
  CUSTOM = "custom-dashboard",
}

const ROOTS = {
  MAIN: {
    YOUTUBE: `${URL_PATH.MAIN}/youtube`,
    TWITTER: `${URL_PATH.MAIN}/twitter`,
    MEDIUM: `${URL_PATH.MAIN}/medium`,
    FORBES: `${URL_PATH.MAIN}/forbes`,
    QUARTZ: `${URL_PATH.MAIN}/quartz`,
    NYC_TIMES: `${URL_PATH.MAIN}/nyc-times`,
    MERCURY_NEWS: `${URL_PATH.MAIN}/mercury-news`,
  },

  CUSTOM: {
    YOUTUBE: `${URL_PATH.CUSTOM}/youtube`,
    TWITTER: `${URL_PATH.CUSTOM}/twitter`,
    MEDIUM: `${URL_PATH.CUSTOM}/medium`,
    MERCURY_NEWS: `${URL_PATH.CUSTOM}/mercury-news`,
    FORBES: `${URL_PATH.CUSTOM}/forbes`,
    QUARTZ: `${URL_PATH.CUSTOM}/quartz`,
    NYC_TIMES: `${URL_PATH.CUSTOM}/nyc-times`,
  },
};

const MAIN = {
  YOUTUBE: {
    ANALYSIS: `${ROOTS.MAIN.YOUTUBE}/analysis`,
    FILTERS: `${ROOTS.MAIN.YOUTUBE}/filters`,
    CSV: `${ROOTS.MAIN.YOUTUBE}/csv`,
  },
  TWITTER: {
    ANALYSIS: `${ROOTS.MAIN.TWITTER}/analysis`,
    FILTERS: `${ROOTS.MAIN.TWITTER}/filters`,
    CSV: `${ROOTS.MAIN.TWITTER}/csv`,
  },
  MEDIUM: {
    ANALYSIS: `${ROOTS.MAIN.MEDIUM}/analysis`,
    FILTERS: `${ROOTS.MAIN.MEDIUM}/filters`,
    CSV: `${ROOTS.MAIN.MEDIUM}/csv`,
  },
  FORBES: {
    ANALYSIS: `${ROOTS.MAIN.FORBES}/analysis`,
    FILTERS: `${ROOTS.MAIN.FORBES}/filters`,
    CSV: `${ROOTS.MAIN.FORBES}/csv`,
  },
  QUARTZ: {
    ANALYSIS: `${ROOTS.MAIN.QUARTZ}/analysis`,
    FILTERS: `${ROOTS.MAIN.QUARTZ}/filters`,
    CSV: `${ROOTS.MAIN.QUARTZ}/csv`,
  },
  NYC_TIMES: {
    ANALYSIS: `${ROOTS.MAIN.NYC_TIMES}/analysis`,
    FILTERS: `${ROOTS.MAIN.NYC_TIMES}/filters`,
    CSV: `${ROOTS.MAIN.NYC_TIMES}/csv`,
  },
  MERCURY_NEWS: {
    ANALYSIS: `${ROOTS.MAIN.MERCURY_NEWS}/analysis`,
    FILTERS: `${ROOTS.MAIN.MERCURY_NEWS}/filters`,
    CSV: `${ROOTS.MAIN.MERCURY_NEWS}/csv`,
  },
};

const CUSTOM = {
  SCRAPING: "/custom-dashboard/scraping",
  SCRAP_CANCELLATION: (activityId: number) => `/user/activity/${activityId}/cancel`,
  YOUTUBE: {
    ANALYSIS: `${ROOTS.CUSTOM.YOUTUBE}/analysis`,
    FILTERS: `${ROOTS.CUSTOM.YOUTUBE}/filters`,
    CSV: `${ROOTS.CUSTOM.YOUTUBE}/csv`,
  },
  TWITTER: {
    ANALYSIS: `${ROOTS.CUSTOM.TWITTER}/analysis`,
    FILTERS: `${ROOTS.CUSTOM.TWITTER}/filters`,
    CSV: `${ROOTS.CUSTOM.TWITTER}/csv`,
  },
  MEDIUM: {
    ANALYSIS: `${ROOTS.CUSTOM.MEDIUM}/analysis`,
    FILTERS: `${ROOTS.CUSTOM.MEDIUM}/filters`,
    CSV: `${ROOTS.CUSTOM.MEDIUM}/csv`,
  },
  FORBES: {
    ANALYSIS: `${ROOTS.CUSTOM.FORBES}/analysis`,
    FILTERS: `${ROOTS.CUSTOM.FORBES}/filters`,
    CSV: `${ROOTS.CUSTOM.FORBES}/csv`,
  },
  QUARTZ: {
    ANALYSIS: `${ROOTS.CUSTOM.QUARTZ}/analysis`,
    FILTERS: `${ROOTS.CUSTOM.QUARTZ}/filters`,
    CSV: `${ROOTS.CUSTOM.QUARTZ}/csv`,
  },
  NYC_TIMES: {
    ANALYSIS: `${ROOTS.CUSTOM.NYC_TIMES}/analysis`,
    FILTERS: `${ROOTS.CUSTOM.NYC_TIMES}/filters`,
    CSV: `${ROOTS.CUSTOM.NYC_TIMES}/csv`,
  },
  MERCURY_NEWS: {
    ANALYSIS: `${ROOTS.CUSTOM.MERCURY_NEWS}/analysis`,
    FILTERS: `${ROOTS.CUSTOM.MERCURY_NEWS}/filters`,
    CSV: `${ROOTS.CUSTOM.MERCURY_NEWS}/csv`,
  },
};

const NOTIFICATIONS = {
  root: "/user/notifications/",
  readAll: "/user/notifications/read/all",
  unreadCount: "/user/notifications/unread/count",
  read: `/user/notifications/read`,
};

export const API_URLS = {
  // Auth
  LOGIN: "user/login",
  REFRESH: "user/refresh",
  SIGNUP: "user/signup",
  LOGOUT: "user/logout",
  FCM_TOKEN: "user/fcm-token",

  // Platforms
  PLATFORMS: "platforms",

  // Activity
  ACTIVITY: "user/activity",

  // MAIN
  main: MAIN,

  // CUSTOM
  custom: CUSTOM,

  // NOTIFICATIONS
  NOTIFICATIONS,
};
